"use strict";

var html = document.querySelector('html');
var closePopup = document.querySelectorAll('.close-popup');
var popupOverlay = document.querySelectorAll('.popup-overlay');
var linkPopupItem = document.querySelectorAll('.link-popup-item');
var popupContainer = document.querySelectorAll('.popup-container');
closePopup.forEach(function (item) {
  item.addEventListener('click', function () {
    item.closest('.popup-container').classList.remove('active');
    html.classList.remove('no-scroll');
  });
});
popupOverlay.forEach(function (item) {
  item.addEventListener('click', function () {
    item.closest('.popup-container').classList.remove('active');
    html.classList.remove('no-scroll');
  });
});
linkPopupItem.forEach(function (item) {
  item.addEventListener('click', function () {
    var target = item.getAttribute("data-target");
    var popup = document.querySelector("." + target);
    popup.closest(".popup-container").classList.add('active');
    html.classList.add('no-scroll');
  });
});